import type { DistributionCenterResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toDistributionCenter } from './toDistributionCenter';

// Builds a normalized `Data.DistributionCenter` domain from a list of DTOs.
function toDistributionCenterDomain(args: {
  dtos: DistributionCenterResponse[];
}) {
  const { dtos } = args;

  const distributionCenterDomain: NormalizedDomain<Data.DistributionCenter> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const distributionCenter = toDistributionCenter(item);
      domainUtility.mutateAdd(distributionCenterDomain, distributionCenter);
    },
  });

  return { distributionCenterDomain };
}

export { toDistributionCenterDomain };
